var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoToStartOverArrow = function SvgGoToStartOverArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.404 4.016c1.314-1.016 3.223-.079 3.223 1.583v12.927c0 1.66-1.909 2.598-3.223 1.582l-8.365-6.463a2 2 0 0 1 0-3.165zm1.223 1.583-8.365 6.463 8.365 6.464zM4.814 3.562a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0v-14a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgGoToStartOverArrow;